//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Home Section
  HOME: 'Home',

  // Training Section
  TRAINING: 'Training',
  TRAINING_SERIES: 'Series',
  TRAINING_MODULES: 'Modules',
  TRAINING_ILT_SESSIONS: 'ILT Sessions',
  TRAINING_LEADERBOARD: 'Global Leaderboard',
  TRAINING_TASKS: 'Tasks',
  TRAINING_FILES: 'Files',
  TRAINING_AI_TUTORIALS: 'Tutorials',

  // Coaching Section
  COACHING: 'Coaching',
  COACHING_SESSIONS: 'Coaching sessions',
  MISSION_REVIEW: 'Mission reviews',

  // Assets Section
  ASSETS: 'Assets',
  ASSETS_ASSETS: 'Assets',
  ASSETS_MY_ASSETS: 'My Assets',
  ASSETS_INTERACTIONS: 'Interactions',

  // Call AI Section
  CALL_AI: 'Call AI',
  CALL_AI_LIBRARIES: 'Libraries',
  CALL_AI_RECORDINGS: 'Recordings',
  CALL_AI_TEAM_RECORDINGS: 'Team recordings',
  CALL_AI_UPCOMING_MEETINGS: 'Upcoming calls',
  CALL_AI_MY_ANALYTICS: 'My analytics',
  CALL_AI_PREFERENCES: 'Preferences',
  CALL_AI_ESSENTIALS: 'Call AI essentials',

  // DSR (Rooms) Section
  DSR: 'Rooms',
  DSR_ROOMS: 'Rooms',
  DSR_TEMPLATES: 'Templates',
  DSR_INSIGHTS: 'Insights',
  DSR_DEALS: 'Deals & contacts',
  DSR_SETTINGS: 'Settings',

  // Seller Intel Section
  SELLER_INTEL: 'Seller Intel',

  // Revenue Intelligence Section
  REVENUE_INTELLIGENCE: 'Revenue Intel',
  REV_INTEL: 'Rev Intel',

  // Team Analytics Section
  TEAM_ANALYTICS: 'Team Analytics',
  TEAM_ANALYTICS_SHORT: 'Analytics',
  TEAM_ANALYTICS_MY: 'My analytics',
  TEAM_ANALYTICS_HIERARCHY_REPORTS: 'Hierarchy reports',
  TEAM_ANALYTICS_RELATIONSHIP_REPORTS: 'Relationship based reports',
  TEAM_ANALYTICS_CALLAI: 'Call AI',
  TEAM_ANALYTICS_COACHING: 'Coaching',
  ANALYTICS_READINESS_INDEX: 'Readiness Index',

  // Assistant Section
  ASSISTANT: 'Assistant',

  // PNC Roleplays Section
  PNC_ROLEPLAYS: 'Roleplays',
  PNC_ROLEPLAYS_PRACTICE: 'Practice roleplays',

  // Deals Section
  DEALS: 'Deals',
});
